/**
 * Проверяет, является ли период строкой в формате ISO 8601
 * @example "P1Y" => true
 * @example "P1Y2M" => true
 * @example "P1Y2M3D" => true
 */
export const validateIso8601Period = (period: unknown): period is string => {
  return typeof period === 'string' ? /^P(?:\d+Y)?(?:\d+M)?(?:\d+D)?$/.test(period) : false;
};
